import MediaGallery from "../components/media/MediaGallery";
import InterviewHighlights from "../components/media/InterviewHighlights";
import VideoSection from "../components/media/VideoSection";

const Media = () => {
  return (
    <div className="page-container">
      <VideoSection />
      <InterviewHighlights />
      <MediaGallery />
    </div>
  );
};

export default Media;